// Port of the tracking interface in traffic-control
import {
  selectors as UserSelectors,
} from 'app/modules/user'
import { SEGMENT_TRACKING_BLACKLIST } from 'constants/ResourcesConstants'
import store from 'containers/store'

export const trackPageView = (pageName, properties = {}) => {
  const currentUser = UserSelectors.currentUser(store.getState())

  if (!window.analytics || SEGMENT_TRACKING_BLACKLIST.includes(currentUser.orgId)) {
    return
  }

  window.analytics && window.analytics.page(pageName, properties)
}

export const identifyUser = (currentUser, traits = {}) => {
  if (!currentUser || !currentUser.orgId || !currentUser.id) {
    return
  } 

  if (currentUser.userJwt && window.drift && window.drift.setUserJwt) {
    window.drift.setUserJwt(currentUser.userJwt)
  }

  return window.analytics && window.analytics.identify(
    `${currentUser.orgId}-${currentUser.id}`, 
    {
      name: currentUser.name,
      email: currentUser.email,
      role: currentUser.role,
      orgId: currentUser.orgId,
      ...traits,
    },
    {
      integrations: { drift: { userJwt: currentUser.userJwt }}
    }
  )
}

export const trackEvent = (eventName, properties) => {
  const currentUser = UserSelectors.currentUser(store.getState())

  if (!window.analytics || SEGMENT_TRACKING_BLACKLIST.includes(currentUser.orgId)) {
    return
  }
  const propertiesWithEmail = Object.assign({}, { email: currentUser.email, orgId: currentUser.orgId }, properties)
  window.analytics.track(eventName, propertiesWithEmail)
}


// WEBPACK FOOTER //
// ./src/scripts/utils/tracking.js